<template>
<div class="simple-page">
  <HeadNav selectedLanguage="en" page="contact" />

  <main class="simple-page__main">
    <h1>Contact Us</h1>

    <section>
      <h2>Contact Secure VPN</h2>
      <p>
        We value your feedback and suggestions. If you have questions about Secure VPN, website content, or general VPN topics, feel free to contact us.
      </p>
      <p>
        Your feedback helps us improve our resources and provide a better experience for visitors.
      </p>
    </section>

    <section>
      <h2>Get in Touch</h2>
      <p>For questions, suggestions, or feedback, please contact us:</p>
      <p>
        <strong>Email:</strong>
        <a href="mailto:support@secureproxyvpn.com">support@secureproxyvpn.com</a>
      </p>
    </section>

    <section>
      <h2>Contact Us For</h2>
      <p>You can reach out regarding:</p>
      <ul>
        <li>Website feedback</li>
        <li>Content suggestions</li>
        <li>Technical questions</li>
        <li>Copyright concerns</li>
        <li>General inquiries</li>
      </ul>
      <p>
        We review all legitimate requests and aim to respond as soon as possible.
      </p>
    </section>
  </main>
</div>
</template>

<script>
import '@/css/vpn-theme.scss';
import HeadNav from '@/components/HeadNav.vue';

export default {
  name: 'ContactUs',
  components: {
    HeadNav,
  },
  mounted() {
    if (typeof document !== 'undefined') {
      document.body.classList.add('vpn-site');
    }
  },
};
</script>

<style lang="scss" scoped>
.simple-page {
  min-height: 70vh;
  background: #fff;
}

.simple-page__main {
  width: var(--vpn-content-width);
  margin: 0 auto;
  padding: 56px 0 72px;
  color: var(--vpn-ink-muted, #5b6475);
}

h1 {
  margin: 0 0 32px;
  color: var(--vpn-ink, #1f2430);
  font-size: 42px;
  line-height: 1.15;
  font-weight: 800;
}

section {
  margin: 0 0 34px;
}

h2 {
  margin: 0 0 14px;
  color: var(--vpn-ink, #1f2430);
  font-size: 26px;
  line-height: 1.25;
  font-weight: 800;
}

p {
  margin: 0 0 14px;
  font-size: 16px;
  line-height: 1.75;
}

ul {
  margin: 0 0 18px 22px;
  padding: 0;
}

li {
  margin: 0 0 8px;
  font-size: 16px;
  line-height: 1.65;
}

a {
  color: var(--vpn-brand, #6d4aff);
  font-weight: 700;
  text-decoration: none;
  overflow-wrap: anywhere;
}

a:hover {
  text-decoration: underline;
}

@media (max-width: 768px) {
  .simple-page__main {
    width: 100%;
    padding: 40px 16px 56px;
    box-sizing: border-box;
  }

  h1 {
    font-size: 34px;
  }

  h2 {
    font-size: 23px;
  }
}
</style>
